module.exports = {"school-name":"Yakima Valley College","logo":"/sites/yvcc/main-logo-white.png","logout-color":"#FFB819","logout-font-color":"#000","header-color":"#A93439","header-border-color":"#FFB819","footer-color":"#000","footer-info":"© YYYY Yakima Valley College | The Write Class™ | © YYYY Boise State University","help-button-color":"#FFB819","help-button-font-color":"#000000"}


//////////////////
// WEBPACK FOOTER
// ./sites/yvcc/site-config.json
// module id = 116
// module chunks = 12